$(function () {
  let section = $('#anfitrion-reservas')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      terrazas: [],
      loaderTerrazas: false,
      terrazaSeleccionada: null,

      filtros: {fecha: null, terraza_id: null},
      reservas: [],
      loader: false,

      scrollTerraza: false,
    },
    mounted() {
      if(terrazaId != null && terrazaId.length > 0) {
        this.terrazaSeleccionada = terrazaId
        this.scrollTerraza = true
      }
      this.getTerrazas()
      this.getReservas()
    },
    methods: {
      setTerrazaSeleccionada(terrazaId = null){
        this.terrazaSeleccionada = terrazaId
        this.getReservas()
      },
      prevMes(){
        this.filtros.fecha = dayjs(this.filtros.fecha).add(-1, 'month')
          .format('YYYY-MM-DD')
        this.getReservas()
      },
      nextMes(){
        this.filtros.fecha = dayjs(this.filtros.fecha).add(1, 'month')
          .format('YYYY-MM-DD')
        this.getReservas()
      },
      getReservas(){
        if (this.loader) {
          return
        }
        this.filtros.terraza_id = this.terrazaSeleccionada
        this.loader = true
        axios
          .get('/anfitrion/reservas-json', {
            params: this.filtros,
          })
          .then((respuesta) => {
            vueApp.loader = false
            if (respuesta.data.error) {
              swal({
                icon: "info",
                title: respuesta.data.error,
                button: {
                  text: "Aceptar",
                  closeModal: true,
                },
              })
              return
            }
            vueApp.reservas = respuesta.data.reservas;
            if(vueApp.filtros.fecha == null){
              vueApp.filtros.fecha = respuesta.data.fecha
            }
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueApp.loader = false
            swal({
              icon: "info",
              title: "Ocurrió un error inesperado",
              button: {
                text: "Aceptar",
                closeModal: true,
              },
            })
          })
      },
      getTerrazas(){
        if (this.loaderTerrazas) {
          return
        }
        this.loaderTerrazas = true
        axios
          .get('/anfitrion/terrazas-json', {
            params: this.filtros,
          })
          .then((respuesta) => {
            vueApp.loaderTerrazas = false
            if (respuesta.data.error) {
              Alert(respuesta.data.error, "info")
              return
            }
            vueApp.terrazas = respuesta.data.terrazas;

            if(vueApp.scrollTerraza){
              if(vueApp.terrazaSeleccionada != null){
                setTimeout(function () {
                  const element = vueApp.$refs[`terraza-${vueApp.terrazaSeleccionada}`];
                  if (element != null && element.length > 0) {
                    element[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }, 500)

              }
              vueApp.scrollTerraza = false
            }
          })
          .catch((error) => {
            ReportErrorLog(error)
            console.error(error)
            vueApp.loaderTerrazas = false
            Alert("Ocurrió un error inesperado", "info")
          })
      },
    }
  });
});
